import { forwardRef, Ref, type SVGProps } from 'react'

const SvgDownloadFile = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="none"
    viewBox="0 0 12 14"
    role="img"
    ref={ref}
    {...props}
  >
    <path
      fill={props.color || `currentColor`}
      fillRule="evenodd"
      d="M7.5.667A.167.167 0 0 0 7.333.5H2.667C1.654.5.833 1.32.833 2.333v9.334c0 1.012.821 1.833 1.834 1.833h6.667c1.012 0 1.833-.82 1.833-1.833V5.098A.167.167 0 0 0 11 4.931H8a.5.5 0 0 1-.5-.5zm-.146 7.11a.5.5 0 0 1 .625.78l-1.662 1.33a.5.5 0 0 1-.315.113h-.006a.5.5 0 0 1-.31-.111L4.021 8.557a.5.5 0 0 1 .625-.78l.854.683V6.167a.5.5 0 1 1 1 0V8.46z"
      clipRule="evenodd"
    />
    <path
      fill={props.color || `currentColor`}
      d="M8.5.883c0-.123.129-.201.224-.124q.121.098.215.227l2.009 2.799c.046.064-.004.146-.082.146h-2.2a.167.167 0 0 1-.166-.166z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgDownloadFile)
export default ForwardRef
